import {
  DisabledInput,
  FormTab,
  Edit as RaEdit,
  TabbedForm,
  TextInput,
  translate,
} from "react-admin";

import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import LogsField from "./fields/LogsField";
import { MonitorIcon } from "../icons";
import MonitorsInput from "./inputs/MonitorsInput";
import PictureInput from "./inputs/PictureInput";
import React from "react";
import SettingsIcon from "@material-ui/icons/Settings";
import Toolbar from "./Toolbar";
import ValueConvertersInput from "../components/inputs/ValueConvertersInput";
import ValueFiltersInput from "../components/inputs/ValueFiltersInput";
import VisibilityIcon from "@material-ui/icons/Visibility";
import compose from "recompose/compose";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";
import withFormStyles from "../components/forms/withFormStyles";

const getSensorTitle = (record, translate) =>
  `${translate("app.sensor")} ${record.id} (${record.name}) - ${translate(
    "resources.sensor.buttons.back_to_device"
  )} ${record.device_id} (${record.device_name})`;

const Edit = ({ classes, translate, ...props }) => {
  const id = props.id?.toString(); // ID della risorsa

  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      className={classes.root}
      title={<DynamicTitleWithTooltip getTitle={getSensorTitle} />}
    >
      <TabbedForm redirect={false} toolbar={<Toolbar />}>
        <FormTab icon={<SettingsIcon />} label="resources.sensor.tabs.config">
          <TextInput source="access_token" fullWidth />
          <DisabledInput source="code" />
          <DisabledInput source="type" label="resources.sensor.label.type" />
          <TextInput source="name" fullWidth />
          <ValueConvertersInput source="value_converters" fullWidth />
          <ValueFiltersInput source="value_filters" fullWidth />
          <PictureInput source="image" />
        </FormTab>
        <FormTab icon={<MonitorIcon />} label="resources.sensor.tabs.monitors">
          <MonitorsInput source="monitors" fullWidth />
        </FormTab>
        <FormTab icon={<VisibilityIcon />} label="resources.sensor.tabs.logs">
          <LogsField fullWidth />
        </FormTab>
      </TabbedForm>
    </RaEdit>
  );
};
export default compose(withFormStyles, translate)(Edit);
